
co = require('co')
api = require 'core/api'
forms = require 'core/forms'
{getQueryVariable} = require('core/utils')
clientSchema = require '../schemas/models/api-client.schema'

{ mapActions, mapState, mapGetters } = require('vuex')

module.exports = Vue.extend({
  data: ->
    prepaids: []
    clients: []
    currentClientFeatures: {}
    ownedClients: []
    oauthProvider: []
    defaultClientVal: clientSchema.properties
    timeZone: 'America/Los_Angeles'
    createLicenseProgress: {
      done: 0,
      total: 0
    }

  created: ->
    return unless me.isAdmin() or me.isLicensor()
    if features?.chinaInfra
      this.timeZone = 'Asia/Shanghai'
    api.apiClients.getAll().then (clients) =>
      @ownedClients = clients
      $.ajax
        type: 'GET',
        url: '/db/feature'
        success: (features) =>
          showGlobalToggles = getQueryVariable('showGlobalToggles', false)
          for i in [0...@ownedClients.length]
            client = @ownedClients[i]
            client.features ?= {}
            @currentClientFeatures[client._id] ?= {}
            for feature in features
              if showGlobalToggles or feature.type isnt 'global'
                client.features[feature._id] = _.assign(_.cloneDeep(feature), client.features[feature._id] ? {})
                @currentClientFeatures[client._id][feature._id] = client.features[feature._id]?.enabled ? false
              else
                delete client.features[feature._id]
            Vue.set(@ownedClients, i, client) # https://vuejs.org/v2/guide/list.html#Caveats
        error: (data) =>
          noty text: 'Failed to find fetch features', type: 'error'
          console.error(data)

  methods: Object.assign {}, mapActions({
      fetchLicenseStats: 'apiClient/fetchLicenseStats',
    }),
    runValidation: (element, requiredProps) ->
      forms.clearFormAlerts(element)
      data = forms.formToObject(element[0])
      result = tv4.validateMultiple(data, {required: requiredProps})
      unless result.valid
        forms.applyErrorsToForm(element, result.errors)
        return
      return data

    onCreateLicense: co.wrap ->
      el = $('#prepaid-form')
      requiredProps = ['email', 'maxRedeemers','startDate', 'endDate']
      data = @runValidation(el, requiredProps)
      unless data
        return
      unless data.maxRedeemers > 0
        forms.setErrorToProperty(el, 'maxRedeemers', 'No of licenses should be greater than 0')
        return
      unless data.endDate > data.startDate
        forms.setErrorToProperty(el, 'endDate', 'End Date should be greater than Start Date')
        return

      emails = data.email.split(',').map((s) -> s.trim())
      @createLicenseProgress.total = emails.length
      @createLicenseProgress.done = 0
      errors = []
      for email in emails
        @createLicenseProgress.done += 1
        unless forms.validateEmail(email)
          errors.push("#{email} - invalid email")
          continue
        try
          user = yield api.users.getByEmail({email})
          attrs = data
          attrs.maxRedeemers = parseInt(data.maxRedeemers)
          attrs.endDate = attrs.endDate + " " + "23:59"   # Otherwise, it ends at 12 am by default which does not include the date indicated
          attrs.startDate = moment.timezone.tz(attrs.startDate, this.timeZone).toISOString()
          attrs.endDate = moment.timezone.tz(attrs.endDate, this.timeZone).toISOString()
          _.extend(attrs, {
            type: 'course'
            creator: user._id
            properties:
              licensorAdded: me.id
          })
          prepaid = yield api.prepaids.post(attrs)
          noty text: "License created for #{email}", timeout: 2000, type: 'success'
        catch err
          console.log(err)
          errors.push("#{email} - #{err?.message || 'unknown error. Check console.'}")

      if errors.length
        forms.setErrorToProperty(el, 'addLicense', "Error<br />#{errors.join("<br />")}")

    onShowLicense: co.wrap ->
      el = $('#prepaid-show-form')
      requiredProps = ['getEmail']
      data = @runValidation(el, requiredProps)
      unless data
        return
      unless forms.validateEmail(data.getEmail)
        forms.setErrorToProperty(el, 'getEmail', 'Please enter a valid email address')
        return

      try
        email = data.getEmail
        user = yield api.users.getByEmail({email})
        this.prepaids = yield api.prepaids.getByCreator(user._id, {data: {allTypes: true}})
        unless this.prepaids.length>0
          forms.setErrorToProperty(el, 'showLicense', 'No licenses found for this user')
          return
        for prepaid in this.prepaids
          prepaid.startDate = moment.timezone(prepaid.startDate).tz(this.timeZone).format('l')
          prepaid.endDate = moment.timezone(prepaid.endDate).tz(this.timeZone).format('l')
          Vue.set(prepaid, 'used' , (prepaid.redeemers || []).length)

      catch err
        console.log(err)
        forms.setErrorToProperty(el, 'showLicense', 'Something went wrong')
        return

    onCreateApiClient: co.wrap ->
      el = $('#client-form')
      requiredProps = ['clientName', 'licenseDaysGranted', 'minimumLicenseDays', 'manageLicensesViaUI', 'manageLicensesViaAPI', 'revokeLicensesViaUI', 'revokeLicensesViaAPI', 'manageSubscriptionViaAPI', 'revokeSubscriptionViaAPI']
      data = @runValidation(el, requiredProps)
      unless data
        return

      if data.minimumLicenseDays < 1
          forms.setErrorToProperty(el, 'minimumLicenseDays', 'minimumLicenseDays should be greater than 0')
          return

      if data.licenseDaysGranted < 0
        forms.setErrorToProperty(el, 'licenseDaysGranted', 'licenseDaysGranted should be greater than or equal to 0')
        return

      try
        attrs = {
          name: data.clientName
          licenseDaysGranted: parseInt(data.licenseDaysGranted)
          minimumLicenseDays: parseInt(data.minimumLicenseDays)
          permissions: {
            manageLicensesViaUI: (data.manageLicensesViaUI == 'true')
            manageLicensesViaAPI: (data.manageLicensesViaAPI == 'true')
            revokeLicensesViaUI: (data.revokeLicensesViaUI == 'true')
            revokeLicensesViaAPI: (data.revokeLicensesViaAPI == 'true')
            manageSubscriptionViaAPI: (data.manageSubscriptionViaAPI == 'true')
            revokeSubscriptionViaAPI: (data.revokeSubscriptionViaAPI == 'true')
          }
        }
        apiClient = yield api.apiClients.post(attrs)
        yield api.apiClients.createSecret({clientID: apiClient._id})
        yield api.apiClients.createAutoClanOwner({clientID: apiClient._id})
        noty text: 'Client created', timeout: 3000, type: 'success'
      catch err
        console.log(err)
        forms.setErrorToProperty(el, 'createClient', 'Something went wrong')
        return

    onUpdateApiClientFeatures: co.wrap ->
      el = $('#client-features-form')
      requiredProps = []
      for client in @ownedClients
        for featureId, feature of client.features
          requiredProps.push client._id + feature.name
      data = @runValidation(el, requiredProps)
      return unless data
      try
        for client in @ownedClients
          for featureId, feature of client.features
            newSetting = data[client._id + feature.name]?[0] is 'on'
            if @currentClientFeatures[client._id][featureId] isnt newSetting
              yield api.apiClients.updateFeature({clientID: client._id, featureID: feature._id}, {enabled: newSetting})
              @currentClientFeatures[client._id][featureId] = newSetting
        noty text: 'Feature flags updated', timeout: 3000, type: 'success'
      catch err
        console.log(err)
        forms.setErrorToProperty(el, 'updateClientFeatures', 'Something went wrong')

    onEditApiClient: co.wrap ->
      el = $('#client-form')
      requiredProps = ['clientName', 'licenseDaysGranted', 'minimumLicenseDays', 'manageLicensesViaUI', 'manageLicensesViaAPI', 'revokeLicensesViaUI', 'revokeLicensesViaAPI', 'manageSubscriptionViaAPI', 'revokeSubscriptionViaAPI']
      data = @runValidation(el, requiredProps)
      unless data
        return

      if data.minimumLicenseDays < 1
        forms.setErrorToProperty(el, 'minimumLicenseDays', 'minimumLicenseDays should be greater than 0')
        return

      if data.licenseDaysGranted < 0
        forms.setErrorToProperty(el, 'licenseDaysGranted', 'licenseDaysGranted should be greater than or equal to 0')
        return

      try
        apiClient = yield api.apiClients.getByName(data.clientName)
        unless apiClient.length>0
          forms.setErrorToProperty(el, 'editClient', 'API client not found')
          return
        attrs = {
          name: data.clientName
          licenseDaysGranted: parseInt(data.licenseDaysGranted)
          minimumLicenseDays: parseInt(data.minimumLicenseDays)
          permissions: {
            manageLicensesViaUI: (data.manageLicensesViaUI == 'true')
            manageLicensesViaAPI: (data.manageLicensesViaAPI == 'true')
            revokeLicensesViaUI: (data.revokeLicensesViaUI == 'true')
            revokeLicensesViaAPI: (data.revokeLicensesViaAPI == 'true')
            manageSubscriptionViaAPI: (data.manageSubscriptionViaAPI == 'true')
            revokeSubscriptionViaAPI: (data.revokeSubscriptionViaAPI == 'true')
          }
        }
        attrs.id = apiClient[0]._id
        apiClient = yield api.apiClients.editClient(attrs)
        noty text: 'API Client updated', timeout: 3000, type: 'success'
      catch err
        console.log(err)
        forms.setErrorToProperty(el, 'editClient', 'Something went wrong')
        return

    onShowApiClient: co.wrap ->
      el = $('#client-show-form')
      requiredProps = ['clientNameShow']
      data = @runValidation(el, requiredProps)
      unless data
        return

      try
        this.clients = yield api.apiClients.getByName(data.clientNameShow)
        unless this.clients.length > 0
          forms.setErrorToProperty(el, 'showClient', 'No API Client found')
          return
        for client in this.clients
          yield this.fetchLicenseStats({ clientId: client._id })
          stats = this.getLicenseStats
          Vue.set(client, 'licenseDaysUsed', stats.licenseDaysUsed)
          Vue.set(client, 'activeLicenses', stats.activeLicenses)
          Vue.set(client, 'licenseDaysRemaining', stats.licenseDaysRemaining)
          Vue.set(client, 'licenseDaysByMonth', stats.licenseDaysByMonth)
          byMonthAndTeacher = []
          for month of stats.licenseDaysByMonth
            for teacher of stats.licenseDaysByMonth[month].teachers
              s = stats.licenseDaysByMonth[month].teachers[teacher]
              byMonthAndTeacher.push {month, teacher, licenseDaysUsed: s.daysUsed, activeLicenses: s.noOfRedeemers}
          Vue.set(client, 'licenseDaysByMonthAndTeacher', byMonthAndTeacher)
      catch err
        console.log(err)
        forms.setErrorToProperty(el, 'showClient', 'Something went wrong')
        return

    onShowAllApiClient: co.wrap ->
      el = $('#client-show-form')

      try
        this.clients = yield api.apiClients.getAll()
        unless this.clients.length > 0
          forms.setErrorToProperty(el, 'showAllClient', 'No API CLient found')
          return

      catch err
        console.log(err)
        forms.setErrorToProperty(el, 'showAllClient', 'Something went wrong')
        return

    onCreateOauth: co.wrap ->
      el = $('#oauth-form')
      requiredProps = ['oauthName', 'lookupUrlTemplate', 'tokenUrl']
      data = @runValidation(el, requiredProps)
      unless data
        return

      try
        attrs = _.pick(data, 'lookupUrlTemplate', 'tokenUrl', 'tokenMethod', 'lookupIdProperty', 'redirectAfterLogin')
        attrs.name = data.oauthName
        attrs.tokenAuth = {
          user: data.tokenAuthUser
          pass: data.tokenAuthPass
        }
        if data.strictSSL
          attrs.strictSSL = (data.strictSSL == 'true')
        oauthProvider = yield api.oauth.post(attrs)
        noty text: 'OAuth Provider created', timeout: 3000, type: 'success'
      catch err
        console.log(err)
        forms.setErrorToProperty(el, 'createProvider', 'Something went wrong')
        return

    onEditOauth: co.wrap ->
      el = $('#oauth-form')
      requiredProps = ['oauthName']
      data = @runValidation(el, requiredProps)
      unless data
        return

      try
        oauthProvider = yield api.oauth.getByName(data.oauthName)
        unless oauthProvider.length>0
          forms.setErrorToProperty(el, 'editProvider', 'OAuth Provider not found')
          return
        attrs = _.pick(data, 'lookupUrlTemplate', 'tokenUrl', 'tokenMethod', 'lookupIdProperty', 'redirectAfterLogin')
        if data.strictSSL
          attrs.strictSSL = (data.strictSSL == 'true')
        attrs.tokenAuth = {
          user: data.tokenAuthUser
          pass: data.tokenAuthPass
        }
        attrs.id = oauthProvider[0]._id
        oauthProvider = yield api.oauth.editProvider(attrs)
        noty text: 'OAuth Provider updated', timeout: 3000, type: 'success'
      catch err
        console.log(err)
        forms.setErrorToProperty(el, 'editProvider', 'Something went wrong')
        return

    onShowOauth: co.wrap ->
      el = $('#oauth-show-form')
      requiredProps = ['oauthNameShow']
      data = @runValidation(el, requiredProps)
      unless data
        return

      try
        this.oauthProvider = yield api.oauth.getByName(data.oauthNameShow)
        unless this.oauthProvider.length > 0
          forms.setErrorToProperty(el, 'showProvider', 'No OAuth Provider found')
          return
      catch err
        console.log(err)
        forms.setErrorToProperty(el, 'showProvider', 'Something went wrong')
        return

    onShowAllOauth: co.wrap ->
      el = $('#oauth-show-form')

      try
        this.oauthProvider = yield api.oauth.getAll()
        unless this.oauthProvider.length > 0
          forms.setErrorToProperty(el, 'showAllProvider', 'No OAuth Provider found')
          return
      catch err
        console.log(err)
        forms.setErrorToProperty(el, 'showAllProvider', 'Something went wrong')
        return


  computed: Object.assign {}, mapGetters({
      getLicenseStats: 'apiClient/getLicenseStats',
    }),
    timestampStart: ->
      return moment.timezone().tz(this.timeZone).format('YYYY-MM-DD')
    timestampEnd: ->
      return moment.timezone().tz(this.timeZone).add(1, 'year').format('YYYY-MM-DD')
    createLicenseIsLoading: ->
      return @createLicenseProgress.done != @createLicenseProgress.total

})

